export default __webpack_public_path__ + "static/media/auth-page-splash-screen.d3249332.png";